import { useMutation, useQueryClient } from '@tanstack/react-query'

import { errorToast, successToast } from 'common/components/toastNotification'
import { useAppSelector } from 'common/hooks/redux'

import { updateCategoryDescription } from '../api'
import { keys } from '../queryKeys'

const useUpdateCategoryDescriptionMutation = () => {
  const queryClient = useQueryClient()
  const accountId = useAppSelector((state) => state.authStates.accountId)

  return useMutation(updateCategoryDescription, {
    onSuccess: (data, variables) => {
      successToast('Category description updated successfully.')
      queryClient.invalidateQueries(
        keys.categoryDetails({
          accountId,
          region: variables.region,
          catalogId: variables.catalogId,
          ccnPath: data.ccn_path.join('::'),
        })
      )
      queryClient.invalidateQueries(
        keys.productCatalogCategories({
          accountId,
          region: variables.region,
          catalogId: variables.catalogId,
        })
      )
    },
    onError: () => {
      errorToast('Failed to update category description. Please try again.')
    },
  })
}

export default useUpdateCategoryDescriptionMutation
